import React, { Fragment } from "react";
import PropTypes from "prop-types";
import CustomPropTypes from "../utils/customPropTypes";
import ImageBlock from "./ImageBlock";
import style from '../../scss/components/Gallery';
export default class Gallery extends React.Component {
  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        value: CustomPropTypes.Image,
        type: PropTypes.string
      })
    )
  };
  render() {
    return (
      <section className="gallery-section">
				<div className="container">
					<ul className="gallery-list">
						{this.props.items.map(function(objGallery, index) {
							return (
								<li key={index}>
									<ImageBlock image={objGallery.value} addWrapper={false} />
								</li>
							);
						})}
					</ul>
				</div>
      </section>
    );
  }
}
